import React from 'react';
import SubstationFilters from './substation-filters';
import LoadMap from './map';
import jsonSchema from './substation-filters.json';
import Navbar from "../../components/Navbar/navbar";
 
const SubstationExplorer = () => {
  return (
    <div >
       <Navbar />
      <div className="filter-row row">
        <SubstationFilters substationTitle={jsonSchema.substationExplorerTitle} />
      </div>
      <div className='row'>
        <LoadMap />
      </div>
    </div>
  );
}
export default SubstationExplorer;

